import { SERVICES_KEYS } from "appLauncher";
import { useState } from "react";
import Banner from "./Banner";
import FinancialInstitutions from "./FinancialInstitutions";
import Guide from "./Guide";
import ProductDescription from "./ProductDescription";
import ServiceAdvantage from "./ServiceAdvantage";

export default function Product() {
  const [selected, setSelected] = useState(0);
  // 自动轮播逻辑
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setSelected((prev) => (prev + 1) % SERVICES_KEYS.length);
  //   }, 6000);
  //   return () => clearTimeout(timer);
  // }, [selected]);

  return (
    <>
      <Banner selected={selected} setSelected={setSelected} />
      <FinancialInstitutions index={SERVICES_KEYS[selected]} />
      <Guide />
      <ProductDescription />
      <ServiceAdvantage />
    </>
  );
}
